import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faMotorcycle } from '@fortawesome/free-solid-svg-icons';
import { BryCard } from '../../components/UI/BryUI';

export const LandingTopDrivers = ({ drivers = [] }) => {
  if (!drivers || drivers.length === 0) return null;

  return (
    <section className="py-5" style={{ backgroundColor: '#f8fafc' }}>
      <div className="container">
        <div className="text-center mb-4">
          <span className="badge rounded-pill mb-2 px-3 py-2" style={{ backgroundColor: 'rgba(14, 171, 176, 0.12)', color: 'var(--bry-accent, #0EABB0)', border: '1px solid var(--bry-accent, #0EABB0)' }}>
            Calificación de excelencia
          </span>
          <h2 className="text-dark fw-bold">Conductores Destacados</h2>
          <p className="text-secondary small">Los mejores evaluados por nuestra comunidad en El Tigre</p>
        </div>

        <div className="row g-3 justify-content-center">
          {drivers.map((driver, idx) => (
            <div key={driver.driver_uid || driver.id || idx} className="col-12 col-sm-6 col-md-4">
              <motion.div
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: idx * 0.1 }}
              >
                <BryCard className="h-100 text-center p-3 border-0 shadow-sm" style={{ backgroundColor: '#ffffff', border: '1px solid rgba(14, 171, 176, 0.3)' }}>
                  <div className="position-relative d-inline-block mx-auto mb-3">
                    {driver.avatar_url ? (
                      <img
                        src={driver.avatar_url}
                        alt={driver.name || 'Conductor'}
                        className="rounded-circle object-fit-cover"
                        style={{ width: '64px', height: '64px', border: '2px solid var(--bry-accent, #0EABB0)' }}
                      />
                    ) : (
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center mx-auto"
                        style={{ width: '64px', height: '64px', backgroundColor: 'rgba(14, 171, 176, 0.15)', color: 'var(--bry-accent, #0EABB0)', border: '2px solid var(--bry-accent, #0EABB0)' }}
                      >
                        <FontAwesomeIcon icon={faMotorcycle} size="lg" />
                      </div>
                    )}
                    <span className="badge position-absolute bottom-0 end-0 rounded-pill bg-light text-dark border" style={{ borderColor: 'var(--bry-accent, #0EABB0)', fontSize: '0.7rem' }}>
                      #{idx + 1}
                    </span>
                  </div>

                  <h6 className="text-dark fw-bold mb-1">{driver.name || driver.full_name || 'Conductor Bryemma'}</h6>
                  <p className="text-secondary small mb-2">{driver.vehicle_model || 'Mototaxi / Delivery'}</p>

                  <div className="d-flex align-items-center justify-content-center gap-1 mb-2 text-warning small">
                    <FontAwesomeIcon icon={faStar} />
                    <span className="fw-bold text-dark ms-1">
                      {driver.rating ? Number(driver.rating).toFixed(1) : '5.0'}
                    </span>
                    <span className="text-secondary">({driver.total_reviews || driver.trips_count || 0} viajes)</span>
                  </div>

                  <span className="badge rounded-pill px-3 py-1 w-100" style={{ backgroundColor: 'var(--bry-accent, #0EABB0)', color: '#ffffff', fontWeight: 600 }}>
                    Verificado Bryemma
                  </span>
                </BryCard>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingTopDrivers;
